/* eslint-disable react/require-default-props */
/* eslint-disable no-undef */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import { ButtonRounded } from './styles';

interface Props {
  icon: JSX.Element;
  onPress: Function;
  color?: string;
}

const ButtonIconRounde: React.FC<Props> = ({ icon, onPress, color }) => (
  <ButtonRounded style={{ backgroundColor: color || undefined }} onClick={() => onPress()}>
    {icon}
  </ButtonRounded>
);
export default ButtonIconRounde;
